<template>
  <ReportBaseSelectFilter
    class="time-off-and-holidays-filter"
    label="Time off / Holidays"
    placeholder="All policies"
    :options="allTimeOffPoliciesAndHolidaysForSelect"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportTimeOffAndHolidaysFilter',
  computed: {
    ...mapGetters(['allTimeOffPoliciesAndHolidaysForSelect']),
  },
};
</script>
